import { useState, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { getSubscriptionStatus, hasActiveSubscription } from '../utils/subscriptionClient';

/**
 * Custom hook to check and manage subscription status
 * @returns {object} - { subscriptionStatus, isSubscribed, loading, error, refetch }
 */
export function useSubscription() {
  const { user, isSignedIn } = useUser();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubscriptionStatus = async () => {
    if (!isSignedIn || !user?.id) {
      setSubscriptionStatus(null);
      setIsSubscribed(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const status = await getSubscriptionStatus(user.id);
      setSubscriptionStatus(status);

      const active = await hasActiveSubscription(user.id);
      setIsSubscribed(active);
    } catch (err) {
      console.error('Failed to fetch subscription status:', err);
      setError(err.message);
      setIsSubscribed(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionStatus();
  }, [isSignedIn, user?.id]);

  return {
    subscriptionStatus,
    isSubscribed,
    loading,
    error,
    refetch: fetchSubscriptionStatus,
  };
}
